module.exports = __webpack_public_path__ + "static/media/card_debit.961d3457.svg";